import { useEffect, useState } from "react";
import { api } from "../lib/api";

/** Petunjuk Kredit Retur milik pelanggan yang sedang diketik kasir (brief owner
 *  22 Sep 2026, I1): kredit hanya bisa dipakai pelanggan dengan nama DAN No HP
 *  yang sama dengan nota retur asal, jadi petunjuknya bergantung pada KEDUA
 *  kolom. SATU sumber untuk Input Nota dan Input Penjualan — dua salinan efek
 *  yang sama pasti berpisah jalan (CLAUDE.md "duplikasi helper").
 *
 *  Server yang memutuskan (`GET /retur/kredit-pelanggan?nama=&no_hp=`, aturan
 *  milik yang sama dengan `pakai_kredit`); hook ini tidak menebak kecocokan.
 *  Ditunda 500 ms supaya tidak menembak server tiap huruf. Kasir tanpa izin
 *  `retur.view` (403) tetap bisa membuat nota — petunjuknya saja yang tidak muncul.
 *
 *  -> { keadaan: "kosong"|"cocok"|"perlu_hp"|"hp_lain", sisa }
 */
export const KREDIT_KOSONG = { keadaan: "kosong", sisa: 0 };

export function ringkasPetunjukKredit(data) {
  const sisa = Number(data?.total_sisa) || 0;
  if (sisa > 0) return { keadaan: "cocok", sisa };
  if (!data?.hp_sah && data?.ada_atas_nama) return { keadaan: "perlu_hp", sisa: 0 };
  if (data?.hp_sah && data?.ada_atas_nama_hp_lain) return { keadaan: "hp_lain", sisa: 0 };
  return KREDIT_KOSONG;
}

export default function useKreditRetur(nama, noHp, aktif = true) {
  const [info, setInfo] = useState(KREDIT_KOSONG);
  useEffect(() => {
    const n = (nama || "").trim();
    if (!aktif || !n) { setInfo(KREDIT_KOSONG); return undefined; }
    let batal = false;
    const t = setTimeout(async () => {
      try {
        const r = await api.get("/retur/kredit-pelanggan", { params: { nama: n, no_hp: noHp || "" } });
        if (!batal) setInfo(ringkasPetunjukKredit(r.data));
      } catch {
        if (!batal) setInfo(KREDIT_KOSONG);
      }
    }, 500);
    return () => { batal = true; clearTimeout(t); };
  }, [nama, noHp, aktif]);
  return info;
}
